



























import {
    Component,
    ComponentConfig,
    ComponentStyle,
    ComponentStyleDefinition,
    InjectComponent,
    Prop,
    Question, QuestionType,
    Vue,
    VueComponent
} from "@zoovu/runner-browser-api";
import {QuestionConfiguration} from "../configuration";

@Component({})
export default class QuestionHeadView extends Vue {

    @Prop()
    question: Question;

    @ComponentConfig(QuestionConfiguration)
    componentConfiguration: QuestionConfiguration;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @InjectComponent("InfoText")
    infoText: VueComponent;

    @InjectComponent("QuestionValidationMessageView")
    questionValidationMessageView: VueComponent;

    infoTextShown: boolean = false;

    get QuestionType(): typeof QuestionType {
        return QuestionType;
    }

    showInfoText() {
        this.infoTextShown = true;
    }

    hideInfoText() {
        this.infoTextShown = false;
    }

    get showImage() {
        return this.componentConfiguration.showImages == true && this.question.images != null && this.question.images[0] != null;
    }

    get shouldShowHint(): boolean {
        return this.question.questionType === QuestionType.CHECKBOX || this.question.questionType === QuestionType.RADIO
    }

}
